import { useState } from "react";
import react from "react";
import careerpath from "../assets/Carrerpath (2).png";
import "./Experience.css";
import { motion } from "framer-motion";
const experiences = [
  {
    id: "apssdc",
    role: "Software Developer",
    company: "APSSDC",
    date: "DEC 2022 – DEC 2023",
    location: "India (Remote)",
    tagline:
      "Built UI components and integrated APIs for enterprise workflow applications.",
    tech: [
      "Java",
      "Spring Boot",
      "React.js",
      "JavaScript",
      "HTML",
      "CSS",
      "REST APIs",
      "JUnit",
      "Git",
      "Agile/Scrum",
    ],
  },
  {
    id: "aicte",
    role: "AWS Cloud Intern",
    company: "AICTE",
    date: "OCT 2021 – DEC 2021",
    location: "India (Remote)",
    tagline: "Deployed and monitored cloud-based applications on AWS.",
    tech: [
      "AWS",
      "EC2",
      "S3",
      "Lambda",
      "CloudWatch",
      "IAM",
      "Monitoring & Logging",
    ],
  },
];

export default function ExperienceTimeline() {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="exp">
      <section className="imagecontainer">
        <motion.img
          src={careerpath}
          alt="logo"
          className="careerpath"
          animate={{ rotateX: 360 }}
          transition={{ duration: 0.4 }}
        />{" "}
        <motion.div
          className="title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <div className="about-container">
            <h2 className="about-heading">About</h2>

            <p className="about-text">
              Enthusiastic <span className="highlight">Software Developer</span>{" "}
              with hands-on experience building internal and customer-facing
              applications using{" "}
              <span className="highlight">Java, JavaScript, and SQL</span>.
              Strong foundation in{" "}
              <span className="highlight">
                full-stack development, RESTful APIs
              </span>
              , Agile workflows, and cloud-based deployments. Experienced in
              writing, testing, and deploying code, supporting data-driven
              workflows, and collaborating within cross-functional teams.
              Motivated to contribute to{" "}
              <span className="highlight">
                internal systems, automation, and continuous improvement
              </span>{" "}
              in fast-paced, product-driven environments.
            </p>
          </div>
        </motion.div>
      </section>

      <section className="expWrap">
        <h1 className="expTitle">Experience</h1>
        <p className="expSub">
          A quick timeline of my internships, with details you can expand.
        </p>

        <div className="timeline">
          <div className="timelineLine" />

          {experiences.map((exp) => {
            const isOpen = openId === exp.id;

            return (
              <article key={exp.id} className="item">
                <div className="dot" />

                <div className="card">
                  <div className="topRow">
                    <div>
                      <h2 className="role">{exp.role}</h2>
                      <p className="company">{exp.company}</p>
                      <p className="meta">
                        📅 {exp.date} • 📍 {exp.location}
                      </p>
                    </div>
                  </div>

                  <p className="tagline">{exp.tagline}</p>

                  <div className="chips">
                    {exp.tech.map((t) => (
                      <span key={t} className="chip">
                        {t}
                      </span>
                    ))}
                  </div>

                  <div
                    id={`panel-${exp.id}`}
                    className={`panel ${isOpen ? "panelOpen" : "panelClosed"}`}
                  >
                    <div className="panelInner"></div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <footer className="main-footerE" id="contactme">
        <p>
          &copy; {new Date().getFullYear()} Naveen Rayapudi. All rights
          reserved.
        </p>
      </footer>
    </section>
  );
}
